import { useState } from 'react';
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { Smile } from 'lucide-react';
import { EMOJI_GROUPS } from './emojiPicker.data';
import type { EmojiPickerProps } from './EmojiPicker.types';
import { useTranslation } from 'react-i18next';

export function EmojiPicker({ onSelect, disabled, trigger }: EmojiPickerProps) {
  const { t } = useTranslation('common');

  const [open, setOpen] = useState(false);

  const handleSelect = (emoji: string) => {
    onSelect(emoji);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            {trigger ?? (
              <Button
                variant="ghost"
                size="mini"
                className="size-8 p-0"
                aria-label={t('ui.emojiPicker.addEmoji')}
                disabled={disabled}
              >
                <Smile className="size-4" />
              </Button>
            )}
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>{t('ui.emojiPicker.addEmoji')}</TooltipContent>
      </Tooltip>
      <PopoverContent className="w-auto p-2" align="start" side="top">
        <Tabs defaultValue={EMOJI_GROUPS[0].id}>
          <TabsList className="w-full">
            {EMOJI_GROUPS.map((group) => (
              <TabsTrigger key={group.id} value={group.id} className="flex-1 text-xs">
                {group.label}
              </TabsTrigger>
            ))}
          </TabsList>
          {EMOJI_GROUPS.map((group) => (
            <TabsContent key={group.id} value={group.id} className="mt-2">
              <div className="grid grid-cols-8 gap-1">
                {group.emojis.map((emoji) => (
                  <Button
                    key={emoji}
                    variant="ghost"
                    size="mini"
                    className="size-7 p-0 text-lg leading-none"
                    aria-label={emoji}
                    onClick={() => handleSelect(emoji)}
                  >
                    {emoji}
                  </Button>
                ))}
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </PopoverContent>
    </Popover>
  );
}
